module.exports = __webpack_public_path__ + "img/people-and-laptop_small.b1347620.svg";